import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { CheckBoxField } from '../../../ui/FormElement';

function IsFree(props) {
  const { isDisabled, ...rest } = props;

  const {
    values: { is_free },
    setFieldValue,
  } = useFormikContext();

  useEffect(() => {
    if (is_free) {
      setFieldValue('billing_duration_month', 0);
      setFieldValue('price_employee_month', 0);
      setFieldValue('price_session', 0);
      setFieldValue('monthly_discount_enable', false);
      setFieldValue('monthly_discount', '');
      setFieldValue('onetime_discount_enable', false);
      setFieldValue('onetime_discount', '');
      setFieldValue('monthly_custom_records', []);
      setFieldValue('onetime_custom_records', []);
      setFieldValue('payment_information_id', '');
    }
  }, [is_free]);

  return (

    <CheckBoxField
      disabled={isDisabled}
      name="is_free"
      inline
    />

  );
}

export default IsFree;
